.ui-dialog__overlay {
  position: fixed;
  inset: 0;
  z-index: var(--lemn-z-modal);
  background: var(--lemn-color-overlay-scrim);
}

/*
 * Centered with auto margins, not translate(-50%, -50%): the open animation
 * animates `transform`, which would override a positioning transform and snap
 * the dialog sideways when the animation ends.
 */
.ui-dialog {
  position: fixed;
  inset: 0;
  z-index: var(--lemn-z-modal);
  display: flex;
  flex-direction: column;
  width: 92vw;
  max-width: 440px;
  height: fit-content;
  max-height: 85vh;
  margin: auto;
  background: var(--lemn-color-surface);
  border: 1px solid var(--lemn-color-border);
  border-radius: var(--lemn-radius-large);
  box-shadow: var(--lemn-shadow-modal);
  color: var(--lemn-color-text);
  font-family: var(--lemn-font-body);
}

/*
 * Size scale gated above the bottom-sheet breakpoint so the mobile full-width
 * sheet always wins — an unscoped [data-size] selector outranks the media
 * override on specificity and would re-narrow the panel on small screens.
 */
@media (min-width: 641px) {
  .ui-dialog[data-size="md"] {
    max-width: 560px;
  }

  .ui-dialog[data-size="lg"] {
    max-width: 720px;
  }

  .ui-dialog[data-size="xl"] {
    max-width: 960px;
  }
}

.ui-dialog__overlay[data-state="open"] {
  animation: fade var(--lemn-duration-fast) var(--lemn-easing-standard);
}

.ui-dialog[data-state="open"] {
  animation: scale-in var(--lemn-duration-fast) var(--lemn-easing-emphasized);
}

/* Mobile: bottom sheet — full-width, bottom-anchored, slides up from the edge. */
@media (max-width: 640px) {
  .ui-dialog {
    inset: auto 0 0 0;
    width: 100%;
    max-width: none;
    height: auto;
    max-height: 90vh;
    margin: 0;
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .ui-dialog[data-state="open"] {
    animation: slide-bottom var(--lemn-duration-normal) var(--lemn-easing-emphasized);
  }
}

.ui-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--lemn-space-4) var(--lemn-space-5);
}

/* Master→detail back affordance: sits where the title would, left-aligned. */
.ui-dialog__back {
  display: inline-flex;
  align-items: center;
  gap: var(--lemn-space-2);
  padding: var(--lemn-space-1) var(--lemn-space-2);
  margin-left: calc(var(--lemn-space-2) * -1);
  border: 0;
  border-radius: var(--lemn-radius-medium);
  background: transparent;
  color: var(--lemn-color-text);
  font-family: inherit;
  font-size: var(--lemn-font-size-body);
  font-weight: var(--lemn-font-weight-medium);
  cursor: pointer;
}

.ui-dialog__back:hover {
  background: var(--lemn-color-surface-muted);
}

/* Title kept for assistive tech while the Back control replaces it visually. */
.ui-dialog__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
  clip: rect(0 0 0 0);
}

.ui-dialog__title {
  font-size: var(--lemn-font-size-heading);
  font-weight: var(--lemn-font-weight-semibold);
  line-height: var(--lemn-line-height-heading);
}

.ui-dialog__content {
  display: flex;
  flex-direction: column;
  gap: var(--lemn-space-3);
  overflow: auto;
  padding: 0 var(--lemn-space-5) var(--lemn-space-4);
}

.ui-dialog__description {
  color: var(--lemn-color-text-muted);
  font-size: var(--lemn-font-size-small);
  line-height: var(--lemn-line-height-small);
}

.ui-dialog__body {
  font-size: var(--lemn-font-size-body);
  line-height: var(--lemn-line-height-body);
}

.ui-dialog__divider {
  height: 1px;
  background: var(--lemn-color-border);
}

.ui-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--lemn-space-2);
  padding: var(--lemn-space-4) var(--lemn-space-5);
}
